import { useEffect } from "react";
import { X, ExternalLink, ShieldCheck } from "lucide-react";

const PAY_LINKS = {
  crypto: {
    monthly: process.env.REACT_APP_WHOP_PAY_CRYPTO_MONTHLY,
    yearly: process.env.REACT_APP_WHOP_PAY_CRYPTO_YEARLY,
  },
  stocks: {
    monthly: process.env.REACT_APP_WHOP_PAY_STOCKS_MONTHLY,
    yearly: process.env.REACT_APP_WHOP_PAY_STOCKS_YEARLY,
  },
  forex: {
    monthly: process.env.REACT_APP_WHOP_PAY_FOREX_MONTHLY,
    yearly: process.env.REACT_APP_WHOP_PAY_FOREX_YEARLY,
  },
  bundle: {
    monthly: process.env.REACT_APP_WHOP_PAY_BUNDLE_MONTHLY,
    yearly: process.env.REACT_APP_WHOP_PAY_BUNDLE_YEARLY,
  },
};

export default function CheckoutModal({ open, onClose, plan, billing, planLabel, price, priceOriginal }) {
  const payUrl = plan && billing ? PAY_LINKS[plan]?.[billing] : null;
  const configured = !!payUrl;

  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      data-testid="checkout-modal"
      className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-sm flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="relative w-full max-w-lg frame p-6 md:p-8"
      >
        <button
          data-testid="checkout-close-btn"
          onClick={onClose}
          className="absolute top-4 right-4 text-white/60 hover:text-white p-2"
          aria-label="Close"
        >
          <X size={20} />
        </button>

        <p className="font-mono-serif text-[10px] tracking-[0.4em] text-white/45">
          CHECKOUT // WHOP
        </p>
        <h2 className="mt-2 font-display text-3xl md:text-4xl">
          {planLabel} · {billing === "yearly" ? "Yearly" : "Monthly"}
        </h2>
        <div className="mt-2 flex items-baseline gap-3">
          {priceOriginal && (
            <span className="font-display text-lg text-white/40 line-through decoration-red-400/70">
              £{priceOriginal}
            </span>
          )}
          <span className="font-display text-3xl">£{price}</span>
          <span className="text-white/50 text-sm">/{billing === "yearly" ? "year" : "month"}</span>
        </div>

        {configured ? (
          <div className="mt-6 space-y-4">
            <p className="text-white/70 text-sm md:text-base">
              You'll be taken to Whop's secure checkout. Pay with <span className="text-white">card or Apple Pay</span>. Group access is delivered instantly the second payment clears.
            </p>
            <a
              href={payUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="pay-with-whop-btn"
              onClick={onClose}
              className="w-full btn-shimmer text-black font-mono-serif text-[11px] tracking-[0.3em] px-6 py-4 rounded-full flex items-center justify-center gap-3 hover:opacity-95 transition"
            >
              PAY WITH WHOP <ExternalLink size={14} />
            </a>
            <div className="flex items-center justify-center gap-2 text-white/45">
              <ShieldCheck size={14} />
              <p className="font-mono-serif text-[10px] tracking-[0.25em]">
                SECURED BY WHOP · INSTANT GROUP ACCESS
              </p>
            </div>
          </div>
        ) : (
          <div className="mt-6 space-y-4">
            <div className="rounded-xl border border-amber-400/30 bg-amber-500/10 p-4 text-amber-100 text-sm">
              This plan is going live soon. In the meantime, DM Issy directly on Telegram to lock in your seat.
            </div>
            <a
              href="https://t.me/issyflash"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="dm-issy-btn"
              className="w-full btn-shimmer text-black font-mono-serif text-[11px] tracking-[0.3em] px-6 py-4 rounded-full flex items-center justify-center gap-3 hover:opacity-95 transition"
            >
              DM @ISSYFLASH ON TELEGRAM
            </a>
          </div>
        )}

        <p className="mt-6 text-center text-[10px] text-white/40 font-mono-serif tracking-[0.25em]">
          POWERED BY WHOP
        </p>
      </div>
    </div>
  );
}
